import { Component, computed, inject, input } from '@angular/core';
import { IonRouterOutlet, ModalController } from "@ionic/angular/standalone";
import { PriceComponent } from '../price/price.component';
import C2U from "@chemist2u/types-client";
import { ItemPage } from 'src/app/pages/item/item.page';
import { ImageComponent } from '../../primitives/image/image.component';
import { StateService } from 'src/app/services/state.service';

@Component({
    selector: 'app-otc-product',
    templateUrl: './otc-product.component.html',
    styleUrls: ['./otc-product.component.scss'],
    imports: [PriceComponent, ImageComponent]
})
export class OtcProductComponent {
  private $state = inject(StateService);
  private modalController = inject(ModalController);
  private routerOutlet = inject(IonRouterOutlet);

  public hasAddress = this.$state.hasAddress;

  public item = input.required<C2U.Elastic.TElasticItemClient>();

  public imageSource = computed(() => {
    const { featuredImage, featuredImageThumb } = this.item();

    if (featuredImageThumb) {
      return featuredImageThumb._url!;
    } else if (featuredImage) {
      return featuredImage._url!;
    } else {
      return undefined;
    }
  });

  click() {
    this.openItemModal();
  }
  
  async openItemModal() {
    // @ts-ignore TODO FIX LIAM
    const meId = this.item()?.id || this.item().objectId;
    const modal = await this.modalController.create({
      id: meId,
      component: ItemPage,
      componentProps: {
        modalItemId: meId
      },
      canDismiss: true,
      presentingElement: this.routerOutlet.nativeEl
    });
    await modal.present();
    const { data, role } = await modal.onWillDismiss();
  }

  truncateName(name: string) {
    if (name.length > 30) {
      return name.substring(0, 15) + "..." + name.substring(name.length - 10, name.length);
    }
    return name;
  }

}